<template>
    <section v-if="regions">
        <div class="container">
            <div class="row">
                <article class="m-cardcomponent" v-for="region in regions" :key="region.Id">
                    <a v-on:click.prevent="RegionSelected(region.Id)" href="#listTab" class="inner" data-toggle="tab" role="tab" aria-selected="true" aria-expanded="false">
                        <div class="image">
                            <thumbnail-image :photo-id="region.Thumbnail"></thumbnail-image>

                            <div class="summary" v-if="region.Summary">
                                <p>
                                    {{region.Summary}}
                                </p>
                            </div>
                        </div>
                        <div class="text">{{region.Name}}</div>
                    </a>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
    import Axios from 'axios'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { searchMixin } from '@/mixins/searchMixin.js'

    export default {
        components: {
            ThumbnailImage
        },

        computed: {
            regions: function () {
                return this.$store.state.search.regions
            }
        },

        created: function () {
            this.Init()
        },

        data() {
            return {
                searchApiUrl: '/umbraco/api/PropertySearchApi/Search'
            }
        },

        methods: {
            Init: function () {
                var vm = this
                vm.loading = true

                const getRegions = function () {
                    return Axios.get('/umbraco/api/PropertySearchApi/Regions', { params: { currentPageId: currentPageId } })
                }

                Axios.all([getRegions()])
                    .then(Axios.spread(function (response) {

                        if (response.data && response.data.length > 0) {
                            vm.$store.dispatch('updateSearchRegions', response.data)
                        }

                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            },

            RegionSelected: function (regionId) {
                this.$store.dispatch('updateSearchFilter', { key: 'filter_16738', value: [regionId] })

                this.$eventHub.$emit('search-regionSelected')

                this.search(true)
            }
        },

        mixins: [searchMixin]
    }
</script>